import { content as terminContent } from '../../../utils';

export const content = {
  ...terminContent,
  draggableId: 'experte',
  heading: 'Trainer:innen',
  fields: {
    name: 'Name:',
    rolle: 'Rolle:',
    sapId: 'SAP-ID:',
    zeitraum: 'Zeitraum:',
    gesellschaft: 'Gesellschaft:',
    email: 'E-Mail:',
  },
} as const;
